import { render, staticRenderFns } from "./cover-back.vue?vue&type=template&id=78e8d904&"
import script from "./cover-back.vue?vue&type=script&lang=js&"
export * from "./cover-back.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports